(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('momentIsSameOrBefore', momentIsSameOrBefore)

    function momentIsSameOrBefore() {
        function momentIsSameOrBeforeFn(value) {
            moment.locale('pt-br');

            var dateStart;

            if (!value)
                return '';

            dateStart = moment(value);

            if (!dateStart.isValid())
                return '';

            return moment().isSameOrBefore(dateStart, null, '[]');
        }

        return momentIsSameOrBeforeFn;
    }
}());